// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"ah","arrowBtnBox":"ah","arrow-btn-wrap-box":"ai","arrowBtnWrapBox":"ai","arrow-btn-text":"aj","arrowBtnText":"aj","arrow-btn-arrow":"ak","arrowBtnArrow":"ak"};